function tabs(target: string | HTMLElement) {

  const tabContainer: null | HTMLElement = target instanceof HTMLElement ? target : document.querySelector(target)
  const dataTabValue = tabContainer?.getAttribute('data-tabs')

  if (!dataTabValue) {
    console.error(`data-tabs value is required in ${tabContainer?.tagName}`, tabContainer)
  }

  const buttons = tabContainer?.querySelectorAll(`[data-tab-target='${dataTabValue}']`)
  const tabContents = tabContainer?.querySelectorAll(`[data-tab-content='${dataTabValue}']`)


  buttons?.forEach((button, index) => {
    tabContents?.forEach((el, eli) => eli !== 0 && el.classList.add('hidden'))

    // listen for click
    button.addEventListener('click', (e) => {
      e.preventDefault()
      tabContents?.forEach(tabContent => (tabContent.classList.add('hidden'), tabContent.classList.remove('active')))
      buttons?.forEach(button => button.classList.remove('active'))
      tabContents?.[index]?.classList.remove('hidden')
      tabContents?.[index]?.classList.add('active')
      button.classList.add('active')
    })
  })

  return {
    tabContainer: tabContainer,
    buttons,
    tabContents,
  }
}

export function useTabs(taget: string | HTMLElement) {
  return tabs(taget)
}